Vue.component('exportMember', {
    template: `
        <div id="exportMember">

            <div class="content exportContent" id="documentContent" v-html="inner"></div>

        </div>
    `,
    data: function() {
        return {
            css: '',
            pn: ''
        };
    },

    props: ['inner'],


    mounted() {

        EventBus.$on('EXPORT_MEMBER', (pn) => {
            this.pn = pn;
            this.getCss();
        });

    },

    methods: {

        getCss() {
            axios.get('?page=getData&action=fetchCss')
                .then(res => {
                    this.css = res.data;
                    this.exportMember(res.data);
                })
                .catch(err => {
                    console.log(err);
                });
        },

        exportMember(css) {
            let elHtml = document.getElementById('exportMember').innerHTML;

            let cssTag = '<style>' + css + '</style>';

            elHtml = cssTag + elHtml
            var link = document.createElement('a');
            var mimeType = 'text/html';

            link.setAttribute('download', this.pn + '.html');
            link.setAttribute('href', 'data:' + mimeType + ';charset=utf-8,' + encodeURIComponent(elHtml));
            link.click();

        }

    }
});
